import React, { useEffect } from "react";
import ApplicationChecklistComponent from "../../components/applicationComponents/applicationChecklist/ApplicationChecklistComponent";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";

export default function ApplicationChecklistPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Type of Application",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);
  return (
    <>
      <ApplicationChecklistComponent disabled={false} />
    </>
  );
}
